module.exports = __webpack_public_path__ + "img/19.2.TN.9df5dd77.png";